<template>
  <div class="information-menu">

    <div class="information-container">
      <img class="information-svg" src="../assets/SVG/INFORMATION.svg" alt="INFORMATION">
    </div>

    <div class="information-content">
      <p class="info-category">映画</p>
      <p class="film-title">イバラ・夜の祈り</p>
      <p class="info-detail indent-text">■2023年11月4日(土)～10(金)&ensp;下北沢トリウッド<br>レイトショー上映</p>
      <p class="info-detail indent-text">■2023年12月8日(金)～14(金)&ensp;アップリンク京都<br>1週間限定公開</p>
      <p class="info-detail indent-text">■2024年2月3日(土)&ensp;シアタードーナツ・オキナワ<br>特別上映会</p>

      <div class="information-footer">
      <img class="informationHP-svg" src="../assets/SVG/HP_icon.svg" alt="home"> <a href="https://minoruhorie.com/ibara/" class="black-link">minoruhorie.com/ibara/</a>
      <img class="X-svg" src="../assets/SVG/X_icon.svg" alt="X"> <a href="https://x.com/ibara_yoru?s=20" class="black-link">@ibara_yoru</a>
      </div>
    </div>

    <div class="info-close-button-container">
    <img :src="require('../assets/SVG/X-BLACK.svg')" alt="Close" @click="infoclosePage">
  </div>


</div>
</template>

  <script>
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    infoclosePage() {
      window.history.back(); 
    }
  }
}
  </script>
  
  <style scoped>

  .information-menu{
  display: block;
  /* border-color: rgb(216, 10, 10);
  border-style: solid;
  border-width: 1px;   */
  height: 100vh;
  align-items: center;
  justify-content: center;

  }

.information-container{
  width: 80%;
  max-width: 640px;
  margin: 7% auto; 
  display: flex;
  justify-content: center;
  /* border-color: rgb(9, 207, 121);
  border-style: solid;
  border-width: 1px;  */

}

  .information-content{
    align-items: center;
    width: fit-content;
    margin: 5vh auto; 
    max-width: 640px;
    padding-top: 0;
    padding-left: 1rem;   
    padding-right: 1rem;   
    /* border-color: rgb(2, 2, 2);
    border-style: solid;
    border-width: 1px;   */
  }

  .indent-text {
  text-indent: -1em;
  padding-left: 1em;
}

  .info-category {
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: rgb(0, 0, 0);
  font-size:1em;
  margin-bottom: 5px;
  /* border-color: rgb(2, 2, 2);
  border-style: solid;
  border-width: 1px;  */
  }

  .film-title{
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: rgb(0, 0, 0);
  font-size:1.3em;
  margin-top: 5px;
  /* border-color: rgb(2, 2, 2);
  border-style: solid;
  border-width: 1px; */
  }

  .info-detail{
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: rgb(0, 0, 0);
  font-size:1em;
  line-height: 1.75em;
  letter-spacing: 2px;
  
  }



  .information-footer{
    font-family: "Zen Kaku Gothic New", sans-serif;
    width: 60%;
    
    max-width: 400px;    
    color: rgb(0, 0, 0);
    text-decoration: none; 
    display: flex;
    align-items: center;
    font-size: 1em;
    margin-top: 3em;
    /* border-color: rgb(0, 0, 0);
    border-style: solid;
    border-width: 1px;  */

  }
  .black-link{
  text-decoration: none; 
  color:black;
  /* border-color: rgb(2, 2, 2);
  border-style: solid;
  border-width: 1px;   */
  margin-right: 1em;
}

.black-link:visited {
  color: rgb(0, 0, 0);
}

.information-svg{
  /* border-color: rgb(2, 2, 2);
    border-style: solid;
    border-width: 1px;   */
    margin-top: 10vh;
    
}

.info-close-button-container {
  position: fixed; 
  top: 6.8vh; 
  right: 4vw;
  z-index: 1000;
  }

  .info-close-button-container img {
  width: 55px; 
  height: 55px;
  cursor: pointer; 
}


@media screen and (max-width: 480px) {

  .information-content{
    align-items: center;
    width: fit-content;
    margin: 3vh auto;
    max-width: 640px;

    padding-left: 1rem;   
    padding-right: 1rem;   
    padding-top: 0;  
    /* border-color: rgb(2, 2, 2);
    border-style: solid;
    border-width: 1px;   */

  }

  .info-detail{
  font-family: "Zen Kaku Gothic New", sans-serif;
  font-weight: 700;
  font-style: normal;
  color: rgb(0, 0, 0);
  font-size:0.7em;
  line-height: 1rem;
  letter-spacing: 2px;
  
  }

  .info-close-button-container img {
  width: 45px;
  height: 45px;
  cursor: pointer;
} 

.information-svg{
  /* border-color: rgb(2, 2, 2);
  border-style: solid;
  border-width: 1px;   */
  margin-top: 15vh;
  width:35%;
}

.information-footer{
    font-family: "Zen Kaku Gothic New", sans-serif;
    width: 60%;
    
    max-width: 400px;    
    color: rgb(0, 0, 0);
    text-decoration: none; 
    display: flex;
    align-items: center;
    font-size: 0.6em;
    margin-top: 3em;
    /* border-color: rgb(0, 0, 0);
    border-style: solid;
    border-width: 1px;  */
  }

  .info-close-button-container {
  position: fixed; 
  top: 4vh; 
  right: 7vw; 
  z-index: 1000; 
  }

  .info-close-button-container img {
  width: 40px; 
  height: 40px; 
  cursor: pointer; 
}



}



  </style>